import Vue from "vue";
import createAuth0Client from "@auth0/auth0-spa-js";

const DEFAULT_REDIRECT_CALLBACK = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
}
  

let instance;

export const getInstance = () => instance;

export const useAuth0 = ({
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirectUri = window.location.origin,
  ...options
}) => {
  if (instance) return instance;

  instance = new Vue({
    data() {
      return {
        loading: true,
        isAuthenticated: false,
        user: {},
        auth0Client: null,
        popupOpen: false,
        error: null
      };
    },
    computed: {
      userRole: function() {
        const r = this.user['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
        if(r && r.length > 0)
        {
          return r[0];
        }
        return '';
      },
      partnerKey: function() {
        return this.user['https://schemas.webinside.com.br/claims/partner_key'];
      },
      customerId: function() {
        return this.user['https://schemas.webinside.com.br/claims/customer_id'];
      },
      customerName: function() {
        return this.user['https://schemas.webinside.com.br/claims/customer_name'];
      },
      businessType: function() {
        return this.user['https://schemas.webinside.com.br/claims/business_type'];
      },
      level: function() {
        return this.user['https://schemas.webinside.com.br/claims/level'];
      },
      userParentId: function() {
        return this.user['https://schemas.webinside.com.br/claims/parentId'];
      },
      externalId: function() {
        return this.user['https://schemas.webinside.com.br/claims/externalId'];
      },
      isPartner: function() {        
        return this.userRole == 'Partner';
      },
      isBackoffice: function() {        
        return this.userRole == 'Backoffice';
      },
      isFinance: function() {        
        return this.userRole == 'Finance';
      },
      isSalesman: function() {
        return this.userRole == 'Salesperson';
      },
      isSalesPerson: function() {
        return this.userRole == 'Salesperson';
      },
      isSeller: function() {
        return this.userRole == 'Seller';
      },
      isLogistic: function() {
        return this.userRole == 'Logistic';
      },
      userInterop: function() {
        return {
          name: this.user.given_name,
          email: this.user.email,
          id: this.externalId,
          role: this.userRole,
          parentId: this.userParentId
        };
      }
    },
    methods: {
      async loginWithPopup(options, config) {
        this.popupOpen = true;

        try {
          await this.auth0Client.loginWithPopup(options, config);
          this.user = await this.auth0Client.getUser();
          this.isAuthenticated = await this.auth0Client.isAuthenticated();
          this.error = null;
        } catch (e) {
          console.error(e);
          this.error = e;
        } finally {
          this.popupOpen = false;
        }
      },
      async handleRedirectCallback() {
        this.loading = true;
        try {
          await this.auth0Client.handleRedirectCallback();
          this.user = await this.auth0Client.getUser();
          this.isAuthenticated = true;
          this.error = null;
        } catch (e) {
          this.error = e;
        } finally {
          this.loading = false;
        }
      },
      loginWithRedirect(o) {
        return this.auth0Client.loginWithRedirect(o);
      },
      getIdTokenClaims(o) {
        return this.auth0Client.getIdTokenClaims(o);
      },
      getTokenSilently(o) {
        return this.auth0Client.getTokenSilently(o);
      },
      getTokenWithPopup(o) {
        return this.auth0Client.getTokenWithPopup(o);
      },
      logout(o) {
        return this.auth0Client.logout(o);
      }
    },
    async created() {
      this.auth0Client = await createAuth0Client({
        ...options,
        client_id: options.clientId,
        redirect_uri: redirectUri,
        audience: options.audience
      });

      try {
        if (
          window.location.search.includes("code=") &&
          window.location.search.includes("state=")
        ) {
          const { appState } = await this.auth0Client.handleRedirectCallback();
          this.error = null;
          onRedirectCallback(appState);
        }
      } catch (e) {
        this.error = e;
      } finally {
        this.isAuthenticated = await this.auth0Client.isAuthenticated();
        this.user = await this.auth0Client.getUser();        
        this.loading = false;        
      }
    }
  });

  return instance;
};

export const Auth0Plugin = {
  install(Vue, options) {
    Vue.prototype.$auth = useAuth0(options);
  }
};